import React, { useState } from 'react'
import classNames from 'classnames'
import { Loading } from '@pandiafi/design-system'

import { BulletinFeaturedImageType } from '../../../../../common/validations'

import { sleep } from 'utils'

interface BulletinFeaturedImageProps {
  featuredImage: BulletinFeaturedImageType
}

export const BulletinFeaturedImage: React.FC<BulletinFeaturedImageProps> = ({
  featuredImage: { url, alt },
}) => {
  const [isLoading, setIsLoading] = useState(true)

  const handleOnLoad = async () => {
    // To remove flickering effect
    await sleep(1000)

    setIsLoading(false)
  }

  return (
    <div
      className={classNames(
        'w-full bg-common-gray-3 mb-6 flex flex-col justify-center items-center rounded-2xl overflow-hidden',
        {
          'h-96': isLoading,
        }
      )}
    >
      {isLoading && <Loading className="w-full" size="small" />}

      <img
        src={url}
        alt={alt}
        onLoad={handleOnLoad}
        className={classNames('w-full transition-transform', {
          'opacity-0 h-0': isLoading,
          'opacity-100 h-auto': !isLoading,
        })}
      />
    </div>
  )
}
